import { Component, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ElementRef, ChangeDetectorRef, NgZone, ViewChild, } from '@angular/core';
import { IColumnDetails, ITableModel } from './model/tableModel';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { L } from '@angular/core/src/render3';
import { animate, style, transition, trigger } from '@angular/animations';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
    ]),
  ]
})
export class TableComponent implements OnInit {
  @Input() selectedValue: any;  // Receive selectedValue from the parent component
  @Output() radioButtonClick = new EventEmitter<any>();
  // @Input() tableDetails: ITableModel = {} as ITableModel;
  @Output() goToDetails = new EventEmitter<string>();
  @Output() shipNowAction = new EventEmitter<any>();
  @Output() DashboardPrompt = new EventEmitter<any>();
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Output() onPageChangeEvent = new EventEmitter<any>();
  @Output() onPageNumberChange = new EventEmitter<any>();
  @Output() addItem = new EventEmitter<any>();
  @Output() selectedRow = new EventEmitter<any>();
  @Output() selectedRowRadio = new EventEmitter<any>();
  @Output() selectedRowToggle = new EventEmitter<any>();
  @Input() isDetailsPageShow: boolean = false;
  @Input() noOfColumnToShowOnModile = 3;
  @Input() cardDetails: any;
  @Input() tableDetails: ITableModel;
  @Input() isCardViewShow: boolean = false;
  @Input() isSearch: boolean;
  @Input() isFormTable: boolean;
  @ViewChild('specificCardList') specificCardList: ElementRef;
  @Output() GoToDetailsCard = new EventEmitter<any>();
  isMobileView: boolean = false;
  selectedRowIndex: number;
  @Input() totalDataCount: number;
  @Input() selectedRowId: number = 0;
  isPaginationShow: boolean;
  tempActionList: any[];
  APIURL: any = environment.apiUrl;
  @Output() OnCheckRate = new EventEmitter<any>();

  activeCardIndex: number | null = null; // Track the active card index
  isBifurcationVisible: boolean = false;
  checkBoxValue: boolean = false;
  isHeaderChecked: boolean = false;

  constructor(
    private mobileDetectionService: MobileDetectionService,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    !this.selectedRowId ? this.selectedRowIndex = 0 : null;
    this.tempActionList = [...(this.tableDetails.actionList ? this.tableDetails.actionList : [])];
    this.isPaginationShow = this.tableDetails.paginationDetails &&
      ((this.totalDataCount > this.tableDetails.paginationDetails.itemsPerPage) ||
        (this.tableDetails.data && !(this.tableDetails.data.length < this.tableDetails.paginationDetails.itemsPerPage)));
    // this.tableDetails.actionList.map(x => {
    //   x.command = (event?: any) => this.onActionClick(event, event.item.label)

    // })
  }

  OnShipAction(Rate: any, Transporter: any, ShortName: any, TransporterId: any, LeadTime: any, VehicleTypeId: any, Type: any, row: any, event: any, isDirectAction: any, index: any, service_code: any) {
    if (Type == 'FTL') {
      var obj: any = {};
      obj.Rate = Rate;
      obj.Transporter = Transporter;
      obj.ShortName = ShortName;
      obj.TransporterId = TransporterId;
      obj.LeadTime = LeadTime;
      obj.VehicleTypeId = VehicleTypeId;
      this.shipNowAction.emit(obj);

    } else if (Type == 'Air') {
      var obj: any = {};
      obj.Rate = Rate;
      obj.Transporter = Transporter;
      obj.ShortName = ShortName;
      obj.TransporterId = TransporterId;
      obj.LeadTime = LeadTime;
      obj.VehicleTypeId = VehicleTypeId;
      obj.service_code = service_code;
      this.shipNowAction.emit(obj);

    } else {
      this.selectedRowIndex = index;
      var obj: any = {};
      obj.row = row;
      obj.event = event;
      obj.isDirectAction = isDirectAction;
      obj.index = index;
      this.shipNowAction.emit(obj);
    }
  }

  // @HostListener('window:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   if (event.target instanceof HTMLElement && event.target.classList.contains('tableMainDiv')) {
  //     this.selectedRowIndex = !this.selectedRowIndex ? 1 : this.selectedRowIndex;
  //     if (event.key === 'ArrowUp' && this.selectedRowIndex > 0) {
  //       this.selectedRowIndex--;
  //     } else if (event.key === 'ArrowDown' && this.selectedRowIndex < this.tableDetails.data.length - 1) {
  //       this.selectedRowIndex++;
  //     } else if (event.key === 'Enter' && this.selectedRowIndex < this.tableDetails.data.length - 1) {
  //       this.goToDetails.emit(this.tableDetails.data[this.selectedRowIndex]);
  //     }
  //     this.selectedRowId = this.tableDetails.data[this.selectedRowIndex].Id ? this.tableDetails.data[this.selectedRowIndex].Id : this.tableDetails.data[this.selectedRowIndex].id;
  //   }
  // }
  ondashboardPrompt(row) {
    this.DashboardPrompt.emit({ row });
  }


  onGoToClick(row: any) {
    this.goToDetails.emit(row);
    this.selectedRowIndex = null;
  }

  onPageNumberChangeFn(event) {
    this.onPageNumberChange.emit(event);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  onActionClick(row, event, isDirectAction, index) {
    this.selectedRowIndex = index;
    if (isDirectAction) {
      const actionName = event
      this.onActionClickOutput.emit({ row, actionName, index });
      return;
    }
    const actionName = event.target.innerText ? event.target.innerText : this.tableDetails.actionList[0].label;
    this.onActionClickOutput.emit({ row, actionName, index });
  }

  onPageChangeFn(pageNo) {
    this.selectedRowIndex = null;
    this.onPageChangeEvent.emit(pageNo);
  }

  showChildRow(data) {
    this.tableDetails.data.forEach(x => {
      if (data.id.toLowerCase() === x.id.toLowerCase()) {
        x.isDownArrow = data.isDownArrow ? false : true;
      }
      if (x.CompanyType !== 'Parent') {
        if (data.id.toLowerCase() === x.parent.toLowerCase()) {
          x.isHide = x.isHide ? false : true;
        }
      }
    })
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  onCheckBoxClick(event, row, index, dataField) {
    debugger;
    // event && this.tableDetails.data.forEach(x => {
    //   if (x.Id !== row.Id) {
    //     console.log(row.Id, 'RowID')
    //   }
    // })
    const isChecked = event;
    if (this.isHeaderChecked) {
      row.isSelected = isChecked;
    } else {
      row.isSelected = isChecked;
    }

    var type: any = 'CheckBox';
    this.selectedRow.emit({ event, row, index, type });

    console.log("Row Selected:", row, "Checked:", isChecked);
  }

  // added by Fahim
  onHeaderCheckBoxClick(event) {
    debugger;
    const isChecked = event;
    this.tableDetails.data.forEach((row) => {
      row.isSelected = isChecked;
    });
    // emit all selected rows
    const selectedRows = this.tableDetails.data.filter((row) => row.isSelected);
    this.selectedRow.emit({ selectedRows, type: 'HeaderCheckBox' });

    console.log("All Selected Rows:", selectedRows);
  }

  onRadioButtonClick(event: any, data: any, dataFieldName: string) {
    this.radioButtonClick.emit({ event, data, dataFieldName });
  }
  onToggleCLick(event, row) {
    this.selectedRowToggle.emit({ event, row })
  }

  getActionList(data, list: any[] = [...this.tableDetails.actionList]): void {
    const filteredList = list.filter((x) => {
      // Keep items where dataField doesn't exist or its value is true
      return x.dataFieldName ? data[x.dataFieldName] === true : true;
    });
    this.tempActionList = [...filteredList];

    for (const item of this.tempActionList) {
      if (window.location.pathname == "/GoodsInward") {
        item.disabled = false;
        // if (item.label == 'Putaway slip' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        if (item.label == 'GRN slip' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Download Putaway' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Upload Putaway' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_GoodsOutward") {
        item.disabled = false;
        if (item.label == 'Send for E-Invoice' && (!data.isOrderConfirm || data.IsEInvoiceDone || data.OutwardType == 'po_rtn_PurchaseOrder')) {
          item.disabled = true;
        }
        if (item.label == 'Print Invoice' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        // if (item.label == 'Pick Slip' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        // if (item.label == 'Packing List' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        if (item.label == 'Download Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Upload Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_Orders") {
        item.disabled = false;
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Generate Outward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/NewPurchaseOrder") {
        item.disabled = false;
        if (item.label == 'Generate Inward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Generate Inward' && data.POStatus == 'Cancelled') {
          item.disabled = true;
        }
        if (item.label == 'Approve GRN MRP Difference' && data.orderStatus != 'Order Reshuffled Pending') {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && data.POStatus == 'Cancelled') {
          item.disabled = true;
        }
        if (item.label == 'Confirm Order' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Confirm Order' && data.POStatus == 'Cancelled') {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_StockTransfer") {
        item.disabled = false;
        if (item.label == 'Generate Outward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
    }
  }

  getCurruncyValue = (data: any, column: IColumnDetails): string => {
    if (data && data[column.dataFieldName]) {
      return (column.symbol ? column.symbol : "") + (data[column.dataFieldName]).toLocaleString('en-US');
    }
    return "";
  }
  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   const rowCount = this.tableDetails.data.length;
  //   switch (event.key) {
  //     case 'ArrowDown':
  //       this.selectedRowIndex = (this.selectedRowIndex + 1) % rowCount;
  //       break;
  //     case 'ArrowUp':
  //       this.selectedRowIndex = (this.selectedRowIndex - 1 + rowCount) % rowCount;
  //       break;
  //     case 'Enter':
  //       if (this.selectedRowIndex >= 0 && this.selectedRowIndex < rowCount) {
  //         this.goToDetails.emit(this.tableDetails.data[this.selectedRowIndex]);
  //       }
  //       break;
  //     default:
  //       // Handle other keys if needed
  //       break;
  //   }
  // }
  onGoTodtailsCard(row, event, index) {
    console.log("Card clicked, Index:", index); // Debugging line
    const actionName = event.target.innerText
      ? event.target.innerText
      : this.tableDetails.actionList[0].label;
    this.activeCardIndex = index; // Set the clicked card as active
    this.GoToDetailsCard.emit({ row, actionName });
  }

  isCardActive(index: number): boolean {
    return this.activeCardIndex === index;
  }

  async OnDownloadClick(data: any) {
    var url: any = this.APIURL + data.DocumentPath;
    window.open(url).print(); return false;
    // this.http
    //   .get(url, { responseType: 'blob' })
    //   .subscribe((response: any) => {
    //     const blob = new Blob([response], { type: 'application/pdf' });
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = data.FileName + "." + data.FileExtension; // Set desired filename
    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    //   });
  }

  @Input() RateBifurcation: any = [];
  selectedIndex: any = 0;
  OnCheckRateClick(event: any, i: any) {
    this.selectedIndex = 0;
    this.isBifurcationVisible = !this.isBifurcationVisible;
    event.isBifurcationVisible = this.isBifurcationVisible;
    event.selectedIndex = i;
    this.selectedIndex = i;
    this.OnCheckRate.emit(event);
  }

  getChangedValue(event, row, index) {
    var type: any = 'Input';
    this.selectedRow.emit({ event, row, index, type });
  }
}
